module.exports = __webpack_public_path__ + "media/images/kahndo-dedbadf75137e131eb568d399dc17f05.png";